import { RemoteFiscalNote } from "../../../../data/usecases/fiscal-note/remote-fiscal";
import { RemoteRecurrency } from "../../../../data/usecases/recurrency/remote-recurrency";
import { FiscalNote, Recurrency } from "../../../../domain/models/fiscal-note";
import { settings } from "../../../configs/settings";
import { makeAxiosHttpClient } from "../../http/axios-http-client-factory";

export const makeRemoteFiscalNote = (): FiscalNote =>
  new RemoteFiscalNote("/fiscal-note", makeAxiosHttpClient(), settings.API_URL);

export const makeRemoteFiscalNoteNote = (): FiscalNote =>
  new RemoteFiscalNote("/fiscal-note/filter", makeAxiosHttpClient(), settings.API_URL);

export const makeRemoteFiscalNoteRecorrency = (): FiscalNote =>
  new RemoteFiscalNote("/fiscal-note/recorrence", makeAxiosHttpClient(), settings.API_URL);

export const makeRemoteRecorrencyFiscalNote = (): Recurrency =>
  new RemoteRecurrency("/fiscal-note/recurrence", makeAxiosHttpClient(), settings.API_URL);

export const makeRemoteCancelFiscalNoteRecorrency = (): FiscalNote =>
  new RemoteFiscalNote("/fiscal-note/cancel-fiscal-recurrence", makeAxiosHttpClient(), settings.API_URL);
